<div class="container pb-5">
   <div class="row">
      <div class="col col-sm-3">
         <b3-button type="button" variant="outlined" tone="default" (b3-click)="navigateToEmissionConsult()">
            <b3-icon name="arrow_back" size="md"></b3-icon>
            Voltar
         </b3-button>
      </div>
      <div class="col col-sm-6">
      </div>
      <div class="col col-sm-3">
         <b3-button class="ml-md-2" type="button" variant="outlined" tone="default" (b3-click)="exportToCSV()">
            <b3-icon name="arrow_downward" size="md"></b3-icon>
            Exportar
         </b3-button>
      </div>
   </div>
   <div class="row">
      <div class="col col-sm-12">
         <ol class="viz-status-steps" aria-label="Status da emissão">
            <li
               [class.completed]="isEmissionCompleted"
               [class.error]="isEmissionCompletedError"
               [class.active]="steperSelectindex === 0">
               Emissão de crédito enviada
            </li>
            <li
               [class.completed]="isAuditCompleted"
               [class.error]="isAuditCompletedError"
               [class.active]="steperSelectindex === 1">
               Pendente de verificação do auditor
            </li>
            <li
               [class.completed]="isReportCompleted"
               [class.error]="isReportCompletedError"
               [class.active]="steperSelectindex === 2">
               Aguardando recebimento do relatório
            </li>
            <li
               [class.completed]="isRegisteredCompleted"
               [class.error]="isRegisteredCompletedError"
               [class.active]="steperSelectindex === 3">
               Emissão realizada na B3
            </li>
         </ol>
      </div>
   </div>
   <div class="div-info">
      <div class="title-row">
         <h3>Projeto gerador de créditos</h3>
      </div>
      
      <div class="row">
         <div class="col col-sm-3">
            <p class="p">Nome do projeto</p>
            <b>{{emission?.project?.name}}</b>
         </div>
         <div class="col col-sm-3">
            <p class="p">Número de emissão</p>
            <b>{{emission?.emissionNumber}}</b>
         </div>
         <div class="col col-sm-3">
            <p class="p">Quantidade total (tCO2)</p>
            <b>{{emission?.emissionQuantity}}</b>
         </div>
         <div class="col col-sm-3">
            <p class="p">Status</p>
            <b>{{emission?.status}}</b>
         </div>
      </div>

      <div class="row">
         <div class="col col-sm-3">
            <p class="p">Data de Registro</p>
            <b>{{emission?.insertDate}}</b>
         </div>

         <div class="col col-sm-6">
            <p class="p">Serial Code</p>
            <b>{{emission?.serialCode}}</b>
         </div>
      </div>

      <div *ngIf="emission?.showReason"  class="row">
         <div class="col col-sm-12">
            <p class="p">
               <i class="viz-status-steps__error-icon info-reject-row" aria-hidden="true"></i>
               Motivo
            </p>
            <b class="row-alert">{{emission?.reasonRejection}}</b>
         </div>
      </div>

      <div class="title-row">
         <h3>Responsável</h3>
      </div>

      <div class="row">
         <div class="col col-sm-3">
            <p class="p">Conta detentor</p>
            <b>{{emission?.holderCode}}</b>
         </div>
         <div class="col col-sm-3">
            <p class="p">CNPJ desenvolvedor</p>
            <b>{{emission?.cpfCnpjCode}}</b>
         </div>
      </div>
      
      <div class="title-row">
         <h3>Período de geração de crédito</h3>
      </div>

      <div class="row">
         <div class="col col-sm-3">
            <p class="p">Data inicial</p>
            <b>{{emission?.startDate}}</b>
         </div>
         <div class="col col-sm-3">
            <p class="p">Data final</p>
            <b>{{emission?.endDate}}</b>
         </div>
      </div>
      
      <div class="title-row">
         <h3>Safra</h3>
      </div>
      <div class="row">
         <div class="col col-sm-12">
            <b3-table size="sm" background="striped" aria-label="Safras da emissão">
               <b3-table-rowgroup group="header">
                  <b3-table-row>
                     <b3-table-cell-header label="Ano da Safra"></b3-table-cell-header>
                     <b3-table-cell-header label="Créditos Gerados nesta Safra"></b3-table-cell-header>
                     <b3-table-cell-header label="Desenvolvedor"></b3-table-cell-header>
                  </b3-table-row>
               </b3-table-rowgroup>
               <b3-table-rowgroup group="body">
                  <b3-table-row *ngFor="let row of itens">
                     <b3-table-cell variant="text" [label]="row.harvestYear || '-'"></b3-table-cell>
                     <b3-table-cell variant="text" [label]="row.quantity ?? '-'"></b3-table-cell>
                     <b3-table-cell variant="text" [label]="row.developerName || '-'"></b3-table-cell>
                  </b3-table-row>
               </b3-table-rowgroup>
            </b3-table>
         </div>
      </div>

      <div class="title-row">
         <h3>Relatório de Monitoramento (RM)</h3>
      </div>
      <div class="row">
         <div class="col col-sm-12">
            <p class="p">Link do relatório</p>
            <a href={{emission?.rmLink}} class="link"  target="_blank">{{emission?.rmLink}}</a>
         </div>
      </div>
      <div class="row">
         <div class="col col-sm-12">
            <p class="p">Descrição do Relatório</p>
            <b class="description">{{emission?.details}}</b>
         </div>
      </div>
   </div>

   <div class="row mt-6 d-flex justify-content-end">
      <!-- Auditor Rejeitar Emissão-->
      <div *ngIf="isButtonAuditRejectEmission"  class="col col-sm-3 d-flex justify-content-end">
               <b3-button type="button" variant="outlined" tone="default" (b3-click)="actionAuditRejectEmission()">
                  Rejeitar Emissão
               </b3-button>
      </div>
      <!-- Auditor Aprovar Emissão-->
      <div *ngIf="isButtonAuditApproveEmission" class="col col-sm-3 d-flex justify-content-end">
               <b3-button type="button" variant="filled" tone="default" (b3-click)="actionAuditAproveEmission()">
                  Aprovar Emissão
               </b3-button>
      </div>

      <!-- Emissor Rejeitar Recebimento do Relatorio-->
      <div *ngIf="isButtonUserRejectReport"  class="col col-sm-3 d-flex justify-content-end">
         <b3-button
            type="button"
            variant="outlined"
            tone="default"
            [disabled]="emission?.showReason || false"
            (b3-click)="actionEmissorRejectReportRecieved()">
            Rejeitar Recebimento do RM
         </b3-button>
      </div>
      <!-- Emissor Aprovar Recebimento do Relatorio-->
      <div *ngIf="isButtonUserAproveReport" class="col col-sm-3 d-flex justify-content-end">
               <b3-button type="button" variant="filled" tone="default" (b3-click)="actionEmissorAproveReportRecivied()">
                  Confirmar Recebimento do RM
               </b3-button>
      </div>
      <!-- Emissor Clonar Emissão-->
      <div *ngIf="isButtonCloneEmission" class="col col-sm-3 d-flex justify-content-end">
               <b3-button type="button" variant="filled" tone="default" (b3-click)="actionCloneEmission()">
                  Clonar Emissão
               </b3-button>
      </div>
   </div>

</div>
